import {ReactComponent as CloseIcon} from "../../ui/icon/Close.svg";

import "./_sign-flow-error-view.scss";

import Button from "../../../component/button/Button";
import ContainerButton from "../../../component/button/container/ContainerButton";
import Typography from "../../../component/typography/Typography";
import {SignFlowState, SignFlowStep} from "../SignFlow.types";
import {useSwapFlowDispatch} from "../../../swap/flow/context/SwapFlowContext";
import {SwapFlowView} from "../../../swap/flow/context/SwapFlowContext.types";
import {createPairNameFromConstituents} from "../../../asset/util/assetUtils";
import {useSwapFormState} from "../../../swap/form/context/SwapFormContext";
import {generateErrorMessage} from "../../util/error/errorUtils";

interface SignFlowErrorViewProps {
  setSignFlowState: React.Dispatch<React.SetStateAction<SignFlowState>>;
  error: unknown;
}

function SignFlowErrorView({error, setSignFlowState}: SignFlowErrorViewProps) {
  const {assetIn, assetOut} = useSwapFormState();
  const dispatchSwapFlowAction = useSwapFlowDispatch();

  return (
    <div className={"is-centered sign-flow-error-view"}>
      <div className={"is-centered sign-flow-error-view__content"}>
        <div className={"is-centered sign-flow-error-view__close-icon-container"}>
          <CloseIcon />
        </div>

        <Typography
          customClassName={"sign-flow-error-view__content__title"}
          tabIndex={0}
          as={"h2"}
          variant={"title"}>
          {`${createPairNameFromConstituents([
            assetIn.asset!,
            assetOut.asset!
          ])} swap failed`}
        </Typography>

        <Typography
          tabIndex={0}
          customClassName={"sign-flow-error-view__description"}
          textColor={"text-gray"}>
          {generateErrorMessage(error)}
        </Typography>
      </div>

      <div className={"has-space-between sign-flow-error-view__button-container"}>
        <Button
          aria-label={"Cancel"}
          typography={"body"}
          onClick={handleGoBackToFormView}
          customClassName={
            "font-weight--medium sign-flow-error-view__button-container__button"
          }>
          {"Cancel"}
        </Button>

        <ContainerButton
          aria-label={"Try again"}
          onClick={handleTryAgainButtonClick}
          customClassName={"sign-flow-error-view__button-container__button"}>
          {"Try again"}
        </ContainerButton>
      </div>
    </div>
  );

  function handleTryAgainButtonClick() {
    setSignFlowState({step: SignFlowStep.WaitingForSign});
  }

  function handleGoBackToFormView() {
    dispatchSwapFlowAction({type: "SET_VIEW", view: SwapFlowView.Form});
  }
}

export default SignFlowErrorView;
